import { Fragment } from 'react';
import { buildSourceBackedHitTermSegments } from '@/shared/quizList/utils/buildSourceBackedHighlightSegments';
import { QUIZ_BANK_SEARCH_HIT_CLASS } from '../consts';
interface QuizBankSearchHitTextProps {
  text: string;
  /** 서버가 준 원문 부분 문자열. 정확 일치로만 찾는다 */
  hitTerms: readonly string[];
}

/** 평문(단원명 등)의 히트 조각만 `<mark data-search-hit>` 으로 감싼다. */
export const QuizBankSearchHitText = ({
  text,
  hitTerms
}: QuizBankSearchHitTextProps) => {
  const segments = buildSourceBackedHitTermSegments(text, hitTerms);
  if (!segments) return <>{text}</>;
  return <span className={QUIZ_BANK_SEARCH_HIT_CLASS} data-sentry-component="QuizBankSearchHitText" data-sentry-source-file="QuizBankSearchHitText.tsx">
      {segments.map((segment, index) => segment.type === 'hit' ? <mark key={index} data-search-hit>
            {segment.value}
          </mark> : <Fragment key={index}>{segment.value}</Fragment>)}
    </span>;
};